import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);


const routes = [
  {
    path: "/",
    name: "booking",
    component: () => import("./views/Booking.vue")
  },
  {
    path: "/room",
    name: "room",
    component: () => import("./views/Room.vue")
  },
  {
    path: "/result.php",
    name: "result",
    component: () => import("./views/Room.vue")
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



export default router

